import { useMutation } from 'react-query'
import {
  CreateProductRequestParams,
  CreateProductRequestResponse,
} from './types'
import { useCreateBetterIdRequest } from 'lib/services/config/betterId-config'

export const useCreateProductRequest = () => {
  const { createBetterIdRequest } = useCreateBetterIdRequest()
  const url = 'operations/product-requests/create'
  return useMutation<
    CreateProductRequestResponse,
    Error,
    CreateProductRequestParams
  >(async (params) => await createBetterIdRequest(url, params))
}
